import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const adminH2HWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const adminContentGrid = style({
  display: "grid",
  gridTemplateColumns: "1fr",
  rowGap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
});

export const gridItem = style({
  gridColumn: "span 1",
  gridColumnStart: 1,
});

export const actionButtons = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
  "@media": {
    [`(min-width: ${breakpoints[1]})`]: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
});
